import * as htmlparser2 from 'htmlparser2';
import PptxGenJS from 'pptxgenjs';
import TextPropsOptions = PptxGenJS.TextPropsOptions;
import TextProps = PptxGenJS.TextProps;

export const roundNumberToDoubleDecimal = (num: number): number => Math.round((num + Number.EPSILON) * 100) / 100;
export const pxToIn = (px: number): number => roundNumberToDoubleDecimal(px / 96);
export const inchToPx = (inch: number): number => inch * 96;
export const clamp = (number: number, min: number, max: number): number => Math.min(Math.max(number, min), max);

export const removeHtmlInString = (str: string): string => {
	const regex = /<[^>]*>/g;
	return str.replace(regex, '');
};

/**
 * simple parser for html to pptxgenjs text props
 * inspired by https://github.com/it-beyondit/html2pptxgenjs/blob/master/src/main.js
 * @param str
 */
export const richTextToPptxText = (str: string): TextProps[] => {
	const textArray: TextProps[] = [];
	const paraSpace = 8;
	let pointerIsInsideList = false;
	let optionsForNextText: TextPropsOptions = {};

	const onOpenTag = (name: string, attributes: { [s: string]: string }): void => {
		switch (name) {
			case 'p':
				setOptionsForPreviousText({ breakLine: true });
				if (!pointerIsInsideList) {
					setOptionsForNextText({ paraSpaceBefore: paraSpace });
				}
				break;
			case 'br':
				setOptionsForNextText({ softBreakBefore: true });
				break;
			case 'ul':
			case 'ol':
				setOptionsForNextText({ paraSpaceBefore: paraSpace });
				pointerIsInsideList = true;
				break;
			case 'li':
				setOptionsForPreviousText({ breakLine: true });
				setOptionsForNextText({ bullet: { indent: 16 } });
				break;
			case 'a':
				setOptionsForNextText({ hyperlink: { url: attributes.href } });
				break;
			case 'strong':
			case 'b':
				setOptionsForNextText({ bold: true });
				break;
			case 'i':
				setOptionsForNextText({ italic: true });
				break;
			default:
				break;
		}
	};

	const onText = (text: string): void => {
		textArray.push({ text, options: { ...optionsForNextText } });

		// reset some one-timers
		setOptionsForNextText({
			bullet: false,
			breakLine: false,
			paraSpaceBefore: 0,
			softBreakBefore: false
		});
	};

	const onCloseTag = (name: string): void => {
		switch (name) {
			case 'ul':
			case 'ol':
				pointerIsInsideList = false;
				break;
			case 'a':
				setOptionsForNextText({ hyperlink: undefined });
				break;
			case 'strong':
			case 'b':
				setOptionsForNextText({ bold: false });
				break;
			case 'i':
				setOptionsForNextText({ italic: false });
				break;
			default:
				break;
		}
	};

	const setOptionsForNextText = (options: TextPropsOptions): void => {
		optionsForNextText = {
			...optionsForNextText,
			...options
		};
	};

	const setOptionsForPreviousText = (options: TextPropsOptions): void => {
		if (textArray.length > 0) {
			textArray[textArray.length - 1].options = {
				...textArray[textArray.length - 1].options,
				...options
			};
		}
	};

	const parser = new htmlparser2.Parser({
		onopentag: onOpenTag,
		ontext: onText,
		onclosetag: onCloseTag
	});

	parser.write(str);
	parser.end();

	// reset some values for the first element, otherwise there could be unwanted space
	if (textArray.length >= 1) {
		textArray[0].options = {
			...textArray[0].options,
			paraSpaceBefore: 0
		};
	}

	return textArray;
};
